import React from "react";

export default function PrivacyPolicyEs() {
  return (
    <>
      <h1>POLÍTICA DE PRIVACIDAD</h1>
      <p>
        <strong>Última actualización:</strong> Junio de 2026
      </p>

      <p>
        En <strong>LigaVirtualF1</strong> nos tomamos muy en serio la privacidad
        de nuestros usuarios. Esta Política de Privacidad describe cómo
        recopilamos, utilizamos y protegemos la información personal que nos
        proporcionas al registrarte en nuestra web{" "}
        <a
          href="https://ligavirtualf1.es"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://ligavirtualf1.es
        </a>
        , de acuerdo con el Reglamento General de Protección de Datos (RGPD) de
        la UE y la legislación española aplicable.
      </p>

      <hr
        style={{
          border: "0",
          height: "1px",
          background: "#ccc",
          margin: "20px 0",
        }}
      />

      <h3>1. RESPONSABLE DEL TRATAMIENTO DE LOS DATOS</h3>
      <p>
        El responsable del tratamiento de tus datos es la administración de la
        comunidad <strong>LigaVirtualF1</strong>. Al ser una comunidad
        recreativa sin ánimo de lucro y sin entidad jurídica comercial, puedes
        ponerte en contacto con el administrador principal para cualquier duda,
        consulta o ejercicio de tus derechos a través del correo electrónico
        oficial de la comunidad o los canales internos de soporte.
      </p>

      <h3>2. DATOS QUE RECOPILAMOS</h3>
      <p>
        Cuando te registras en nuestra plataforma, recopilamos los siguientes
        datos personales:
      </p>
      <ul>
        <li>
          <strong>Datos obligatorios:</strong> Nombre, apellidos, nombre de
          usuario (Nick), dirección de correo electrónico, país (y comunidad
          autónoma si seleccionas España), contraseña (encriptada) y el medio
          por el cual nos conociste.
        </li>
        <li>
          <strong>Datos opcionales:</strong> Fecha de nacimiento y foto de
          perfil (avatar).
        </li>
      </ul>

      <h3>3. FINALIDAD DEL TRATAMIENTO DE LOS DATOS</h3>
      <p>
        Utilizamos la información recopilada exclusivamente para los siguientes
        fines:
      </p>
      <ul>
        <li>
          Gestionar tu registro de usuario, tu perfil de piloto y tu
          participación en los campeonatos organizados por la comunidad.
        </li>
        <li>
          Mostrar tu nombre de usuario, país/comunidad autónoma y estadísticas
          de carrera en las tablas de clasificación y resultados públicos de la
          web de forma histórica.
        </li>
        <li>
          Retransmitir y publicar las carreras en plataformas de streaming (como
          YouTube, Twitch o TikTok). Al participar en los campeonatos oficiales
          de la Comunidad, aceptas que tu nombre de usuario y telemetría
          aparezcan en dichos contenidos audiovisuales.
        </li>
        <li>
          Enviarte notificaciones técnicas o avisos importantes relacionados con
          la liga por correo electrónico.
        </li>
      </ul>

      <h3>4. LEGITIMACIÓN PARA EL TRATAMIENTO</h3>
      <p>
        La base legal para tratar tus datos es el{" "}
        <strong>consentimiento explícito</strong> que nos otorgas al marcar la
        casilla de aceptación de esta política durante el proceso de registro.
      </p>

      <h3>5. PLAZO DE CONSERVACIÓN Y PERSISTENCIA DE DATOS DEPORTIVOS</h3>
      <p>
        Conservaremos tus datos de perfil mientras mantengas tu cuenta activa.
        Si decides darte de baja de la comunidad o solicitas la cancelación de
        tu cuenta, debes tener en cuenta que, por motivos de integridad de la
        competición, estadísticas generales e interés legítimo histórico,{" "}
        <strong>
          los resultados de tus carreras, tiempos, clasificaciones y registros
          deportivos en la web permanecerán visibles de forma permanente
        </strong>
        , pudiendo ser vinculados a tu antiguo nombre de usuario o anonimizados,
        pero nunca eliminados para no alterar el histórico de los campeonatos.
        Asimismo, los contenidos audiovisuales ya publicados (retransmisiones de
        carreras en YouTube/TikTok) no serán eliminados ni editados.
      </p>

      <h3>6. DESTINATARIOS Y TRANSFERENCIA DE DATOS</h3>
      <p>
        LigaVirtualF1 <strong>no vende, alquila ni comparte</strong> tus datos
        personales con terceras empresas ni organizaciones. Tus datos permanecen
        seguros en los servidores donde está alojada nuestra web.
      </p>
      <p>
        Ten en cuenta que al participar en una liga online, tu nombre de
        usuario, avatar y estadísticas de carrera serán públicos y visibles para
        el resto de usuarios de Internet dentro de las secciones de
        clasificaciones y retransmisiones de la web.
      </p>

      <h3>7. TUS DERECHOS Y LIMITACIONES</h3>
      <p>
        El RGPD te otorga derechos de Acceso, Rectificación, Limitación y
        Oposición. No obstante, el derecho de Supresión (Olvido) está sujeto a
        limitaciones en nuestra plataforma debido a la naturaleza competitiva de
        la actividad:
      </p>
      <ul>
        <li>
          Puedes solicitar la eliminación de tus datos personales de contacto
          (como tu correo electrónico o datos privados de perfil), lo que
          conllevará la baja inmediata de la plataforma.
        </li>
        <li>
          <strong>Limitación:</strong> El derecho de supresión NO se aplicará a
          los datos de resultados de carreras, clasificaciones históricas ni a
          las grabaciones en vídeo de las competiciones en las que hayas
          participado, ya que su eliminación perjudicaría el registro histórico
          de la comunidad y los derechos del resto de participantes.
        </li>
      </ul>
      <p>
        Para solicitar la baja de tu cuenta o modificar tus datos, puedes
        ponerte en contacto con la administración a través de nuestros canales
        oficiales.
      </p>

      <h3>8. SEGURIDAD DE LOS DATOS</h3>
      <p>
        Implementamos las medidas de seguridad técnicas necesarias (como cifrado
        de contraseñas y conexiones seguras mediante HTTPS) para proteger tus
        datos contra accesos no autorizados, pérdidas o alteraciones. Sin
        embargo, recuerda que ninguna transmisión por Internet es 100% segura.
      </p>
    </>
  );
}
